import axios from 'axios';

import { getAccessToken } from './jwt';

import { Environment } from '@/env';

export const client = axios.create({
  baseURL: Environment.WEBSITE_URL + '/api',
});

client.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export * from './provider';
export * from './jwt';
